<script>
  import {getContext} from 'svelte';
  import {Modal} from '@/widgets/index';
  import lang from './CompatibilityPage.lang';

  const LG = getContext('LG');
</script>

<style>
  .main {
    padding: 8px;
  }
  .title {
    font-size: 16px;
    line-height: 24px;
  }
  .title1 {
    margin-top: 10px;
    font-size: 14px;
    line-height: 22px;
  }
  .footer {
    padding: 8px;
    margin-top: 30px;
    text-align: right;
  }
  .button {
    display: inline-block;
    margin-left: 16px;
    cursor: pointer;
    background: #003398;
    color: #fff;
    border-radius: 2px;
    border: 1px solid #003398;
    padding: 0 24px;
    height: 40px;
    line-height: 38px;
  }
  .button:hover {
    opacity: 0.8;
  }
  label {
    width: 16px;
    height: 16px;
    line-height: 16px;
    border-radius: 2px;
    cursor: pointer;
    position: absolute;
    border: 1px solid rgba(0, 0, 0, 0.15);
    top: 2px;
    left: 0;
  }
  input[type=checkbox] {
    visibility: hidden;
  }
  .input:checked + :global(label:before) {
    display: block;
    content: "\2713";
    text-align: center;
    font-size: 12px;
    color: #fff;
    background: #003398;
  }
  .dn {
    display: none;
  }
  :global(.incompatible) .warp {
    display: block;
  }
  .mt30 {
    margin-top: 30px;
  }
</style>
<div id="compatibility" class="warp dn">
  <Modal style="max-width:520px;padding:24px;">
    <div class="p24 lh24 df b f16 T2" slot="header">
      <div class="title fw2 T1">{LG(lang.Note)}</div>
    </div>
    <div class="body">
      <div class="main">
        <div class="title1 T2">{LG(lang.Note1)}</div>
        <div class="title1 T2">{LG(lang.Note2)}</div>
        <div class="title1 T2">{LG(lang.Note3)}</div>
      </div>
      <div class="tc mt30"><a href="https://www.google.com/chrome/" target="_blank" rel="noopener noreferrer nofollow"><img src="https://phemex.com/font/chrome.svg" alt="chrome"/></a></div>
    </div>
    <div class="footer df fdr jcsb" slot="footer">
      <div class="pr">
        <input id="compatibilityCheckbox" class="input" type="checkbox"/>
        <label for="compatibilityCheckbox"></label>
        {LG(lang.Show)}
      </div>
      <span class="button" id="compatibilityButton">{LG(lang.Confirm)}</span>
    </div>
  </Modal>
</div>
